import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { StoreState } from '../../models/states/StoreState';
import '../../styles/probingLoader.css';

interface ProbingLoadingIndicatorProps {
    isLoading: boolean;
}

const ProbingLoadingIndicator: React.FC<ProbingLoadingIndicatorProps> = ({ isLoading }) => {
    const [visible, setVisible] = useState(false);

    // Add a small delay before showing the loading indicator to prevent flashing
    useEffect(() => {
        let timeoutId: NodeJS.Timeout;

        if (isLoading) {
            timeoutId = setTimeout(() => {
                setVisible(true);
            }, 300); // Show after 300ms delay
        } else {
            setVisible(false);
        }

        return () => {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
        };
    }, [isLoading]);

    if (!visible) {
        return null;
    }

    return (
        <div className="probing-overlay">
            <div className="probing-loading__container">
                <div className="probing-loading__a"></div>
                <div className="probing-loading__b"></div>
            </div>
        </div>
    );
};

const mapStateToProps = (state: StoreState) => ({
    isLoading: state.interview.variables.probingStatus.isLoading
});

export default connect(mapStateToProps)(ProbingLoadingIndicator); 